/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React, { useState } from 'react';
import {
    array,  object, number, func, bool,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';
import AddonModal from './AddonModal';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import WineInformation from './WineInformation';

const styles = (theme) => ({
    headerContainer: {
        display: 'grid',
        gridTemplateAreas: '"selectionContent wineInfo"',
        padding: '10px 0px 12px 0px',
        position: 'relative',
        '@media screen and (max-width: 900px)': {
            gridTemplateAreas: '"selectionContent" "wineInfo"',
        },
    },
    selectionContent: {
        gridArea: 'selectionContent',
        display: 'flex',
    },
    selection: {
        fontSize: '1rem',
        fontWeight: 700,
        lineHeight: '18px',
        paddingRight: '10px',
    },
    selectionCount: {
        fontSize: '0.875rem',
        lineHeight: '18px',
    },
    wineInfo: {
        gridArea: 'wineInfo',
        fontSize: '0.875rem',
        lineHeight: '18px',
        textAlign: 'right',
        textDecoration: 'underline',
        textTransform: 'capitalize',
        cursor: 'pointer',
        '@media screen and (max-width: 900px)': {
            textAlign: 'left',
            padding: '.5rem 0',
        },
    },
    frameContainer: {
        border: '1px dashed #787878',
        width: '73px',
        height: '78px',
    },
    frameCotainer: {
        paddingBottom: '15px',
        overflowX: 'scroll',
    },
    frame: {
        display: 'flex',
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: 'rgba(156, 156, 156, 1)',  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '3px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
    },
    addition: {
        alignItems: 'center',
        display: 'flex',
        textAlign: 'center',
        fontSize: '2rem',
    },
    selectedContainer: {
        boxShadow: '0px 0px 0px 2px rgb(44 128 19)',
        width: '73px',
        height: '75px',
        marginLeft: '-1px',
        display: 'flex',
    },
    mainContainer: {
        paddingLeft: '4px',
    },
    selectedButton: {
        marginTop: '2px',
        height: '75px',
    },
    deleteItem: {
        filter: 'invert(100%)', // white image convert to black
        width: '1.8rem',
        cursor: 'pointer',
        marginTop: '-3px',
    },
});

const SelectedAddOnV3 =  (
    {
        selectAddons,
        classes,
        handleQuantity,
        handleDecrement,
        handleIncrement,
        handleCount,
        error,
        maxAddons,
    },
) => {
    const dispatch = useDispatch();
    // buildImgPath is using 2x dimension request to improve image clarity.
    const buildImgPath = (path, name) => (`${path + name}x.jpg?height=150&auto=webp`);
    const [selectedOption, setSelectedOption] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const handlePopup = (item) => {
        setSelectedOption(item);
        setModalOpen(true);
    };
    const nonSelectedAddons = maxAddons - selectAddons?.length;
    const matchAddons = (addOnId) => selectAddons?.some((item) => item.id === addOnId);
    return (
        <div className={classes.mainContainer}>
            <div className={classes.headerContainer}>
                <div className={classes.selectionContent}>
                    <div className={classes.selection}>
                        Your Selections
                    </div>
                    <div className={classes.selectionCount}>
                        ({handleQuantity} of up to {maxAddons} extras)
                    </div>
                </div>
                <WineInformation classes={classes} selectAddons={selectAddons} />
            </div>
            <div className={maxAddons > 2 ? `${classes.frame} ${classes.frameCotainer}` : classes.frame}>
                {selectAddons?.map((item, index) => (
                    <div className={classes.addition}>
                        <span
                            role="presentation"
                            className={classes.deleteItem}
                            data-testid="remove-button"
                            onClick={() => {
                                handleDecrement(selectAddons?.[index]);
                                dispatch(trackEvent({
                                    eventCategory: 'Inline Addons',
                                    eventAction: 'Removed Item',
                                    eventLabel: selectAddons?.[index]?.id || '',
                                }));
                            }}
                        >
                            <img src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt8803188c991cd120/632ae23d8966566ecdfbe08e/delete.svg?auto=webp" alt="Remove Logo" />
                        </span>
                        <div
                            onClick={() => {
                                handlePopup(selectAddons?.[index]);
                            }}
                            role="button"
                            onKeyDown={() => {}}
                            tabIndex={-1}
                            className={classes.selectedButton}
                            data-testId="addon_Image"
                        >
                            <img className={classes.selectedContainer} src={buildImgPath(item?.image?.path, item?.image?.name)} alt="addOns" />
                        </div>
                    </div>
                ))}
                {[...Array(nonSelectedAddons)].map(() => (
                    <div className={classes.addition}>
                        <AddIcon />
                        <div className={classes.frameContainer} />
                    </div>
                ),
                )}
            </div>

            {modalOpen &&  <AddonModal selectedOption={selectedOption} matchAddons={matchAddons} open={modalOpen} setOpen={setModalOpen} handleIncrement={handleIncrement} handleDecrement={handleDecrement} handleQuantity={handleCount} error={error} />}
        </div>

    );
};

SelectedAddOnV3.propTypes = {
    classes: object.isRequired,
    selectAddons: array,
    handleQuantity: number,
    handleDecrement: func,
    handleIncrement: func,
    handleCount: func,
    error: bool,
    maxAddons: number.isRequired,
};

SelectedAddOnV3.defaultProps = {
    selectAddons: [],
    handleQuantity: 0,
    handleIncrement: () => {},
    handleDecrement: () => {},
    handleCount: () => {},
    error: false,
};

export default (withStyles(styles)(SelectedAddOnV3));
